import * as S from './CommonPaymentSideSection.styles';
import useCurrentBreakpoint from '@britishcouncil/react-extro-ui/dist/hooks/useCurrentBreakpoint';
import { ProductsSummaryProps } from '../../../summary/productsSummary';
import ProductsSummary from '../../../summary/productsSummary/ProductsSummary';
import { TimerSection, TimerSectionProps } from '../../../timer';
import ErrorSummaryMessage from '../../../errorSummary/ErrorSummaryMessage';
import { useErrorSummaryContext } from '@contexts';
import { ConfirmPaymentButton } from '../../../confirmPaymentButton';
interface CommonPaymentSideSectionProps {
  paymentId?: string;
  timer?: TimerSectionProps;
  productSummary?: ProductsSummaryProps;
  displayPaymentButton?: boolean;
  customPaymentButtonText?: string;
  paymentPageLogoImageUrl?: string;
  onBeforePaymentSubmit?: () => void;
}

export const PAYMENT_SUBMITTED_KEY = (paymentId?: string) => `${paymentId}-submitted`;

const CommonPaymentSideSection = ({
  paymentId,
  timer,
  productSummary,
  displayPaymentButton,
  customPaymentButtonText,
  paymentPageLogoImageUrl,
  onBeforePaymentSubmit,
}: CommonPaymentSideSectionProps) => {
  const breakpoint = useCurrentBreakpoint();
  const { isErrorSummaryMessageVisible } = useErrorSummaryContext();
  const paymentSubmitted = sessionStorage.getItem(PAYMENT_SUBMITTED_KEY(paymentId));

  if (breakpoint === 'lg') {
    return (
      <S.StickyRoot className="sticky">
        {isErrorSummaryMessageVisible && <ErrorSummaryMessage />}
        {timer && <TimerSection {...timer} />}
        {productSummary && <ProductsSummary {...productSummary} />}
        {displayPaymentButton && paymentSubmitted !== 'true' && (
          <ConfirmPaymentButton
            formId="payment-form"
            id="btn-pay"
            paymentPageLogoImageUrl={paymentPageLogoImageUrl}
            customText={customPaymentButtonText}
            onBeforeSubmit={onBeforePaymentSubmit}
          />
        )}
      </S.StickyRoot>
    );
  }

  return (
    <>
      {timer && (
        <S.StickyRoot className="sticky">
          {isErrorSummaryMessageVisible && <ErrorSummaryMessage />}
          <TimerSection {...timer} />
        </S.StickyRoot>
      )}
      <S.Root>{productSummary && <ProductsSummary {...productSummary} />}</S.Root>
    </>
  );
};

export default CommonPaymentSideSection;
